<div class="h-100" (mouseenter)="addHover()" (mouseleave)="removeHover()">
    <div class="teams-text mr-3" #pop="ngbPopover" [ngbPopover]="teamsPopover" placement="bottom" containerClass="cx-one-ui teams-popover" container="body" triggers="manual"
        [disablePopover]="teams?.length <= 0">
        {{ teams.length }}
        <span cvLocalizedText langSection="Top_Categories_Module" langKey="Teams">teams</span>
    </div>
</div>

<ng-template #teamsPopover>
    <div class="teams-popover-list" (mouseenter)="addHover()" (mouseleave)="removeHover()">
        <p *ngFor="let team of teams" class="teams-popover-list-item">
            {{ team.GroupName }}
        </p>
    </div>
</ng-template>
